import React from "react";
import { Typography, useTheme } from "@mui/material";

/**
 * PerlLabelSmall Component
 *
 * Reusable small label typography for form fields
 * Used for labels like "Product Name:", "Market Positioning:", etc.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - The label text content
 * @param {object} [props.sx] - Additional MUI sx props for customization
 */
const PerlLabelSmall = ({ children, sx = {} }) => {
  const theme = useTheme();
  const perlColors = theme.custom?.perlColors || {};

  return (
    <Typography
      variant="caption"
      sx={{
        fontWeight: 600,
        color: perlColors.textPrimary,
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
};

export default PerlLabelSmall;
